import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FiltersFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.94 11.38C14.36 11.38 13.02 10.04 13.02 8.5C13.02 6.96 14.36 5.62 15.94 5.62C17.52 5.62 18.86 6.96 18.86 8.5C18.86 10.04 17.52 11.38 15.94 11.38ZM5.32 9.42V7.58H11.62V9.42H5.32ZM8.06 18.3C6.48 18.3 5.14 16.96 5.14 15.42C5.14 13.88 6.48 12.54 8.06 12.54C9.64 12.54 10.98 13.88 10.98 15.42C10.98 16.96 9.64 18.3 8.06 18.3ZM18.68 16.34H12.2V14.5H18.68V16.34Z" />
    </SvgIcon>
  );
});
